// Active Filters Badge Component
// Displays active analytics filters with the ability to remove them individually
import React from 'react';
import { Filter, XCircle } from 'lucide-react';
import { Button } from '../ui/button';

const ActiveFiltersBadge = ({
  language,
  activeFilters,
  onRemoveFilter,
  onResetAll,
  variant = 'purple' // 'purple' for paper, 'green' for real
}) => {
  if (!activeFilters || activeFilters.length === 0) return null;
  
  const variantColors = {
    purple: {
      container: 'bg-purple-500/10 border-purple-500/30',
      title: 'text-purple-400',
      button: 'text-purple-400 hover:text-white hover:bg-purple-500/20'
    },
    green: {
      container: 'bg-green-500/10 border-green-500/30',
      title: 'text-green-400',
      button: 'text-green-400 hover:text-white hover:bg-green-500/20'
    }
  };
  
  const colors = variantColors[variant] || variantColors.purple;
  
  const badgeColorClasses = {
    blue: 'bg-blue-500/20 text-blue-400 border-blue-500/30 hover:bg-blue-500/30',
    cyan: 'bg-cyan-500/20 text-cyan-400 border-cyan-500/30 hover:bg-cyan-500/30',
    green: 'bg-green-500/20 text-green-400 border-green-500/30 hover:bg-green-500/30',
    yellow: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30 hover:bg-yellow-500/30',
    red: 'bg-red-500/20 text-red-400 border-red-500/30 hover:bg-red-500/30',
    indigo: 'bg-indigo-500/20 text-indigo-400 border-indigo-500/30 hover:bg-indigo-500/30',
    purple: 'bg-purple-500/20 text-purple-400 border-purple-500/30 hover:bg-purple-500/30',
  };
  
  return (
    <div className={`mb-4 p-3 rounded-lg border ${colors.container}`}>
      <div className="flex items-center justify-between mb-2">
        <div className={`text-xs font-medium ${colors.title} flex items-center gap-1`}>
          <Filter className="w-3 h-3" />
          {language === 'fr' ? 'Filtres actifs' : 'Active filters'}
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={onResetAll}
          className={`h-6 px-2 text-xs ${colors.button}`}
        >
          <XCircle className="w-3 h-3 mr-1" />
          {language === 'fr' ? 'Tout effacer' : 'Clear all'}
        </Button>
      </div>
      <div className="flex flex-wrap gap-2">
        {activeFilters.map((filter, index) => (
          <button
            key={`${filter.type}-${filter.value}-${index}`}
            onClick={() => onRemoveFilter(filter)}
            className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs border transition-colors cursor-pointer ${badgeColorClasses[filter.color] || badgeColorClasses.purple}`}
            title={language === 'fr' ? 'Cliquez pour supprimer' : 'Click to remove'}
          >
            {filter.label}
            <XCircle className="w-3 h-3 opacity-70 hover:opacity-100" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default ActiveFiltersBadge;
